import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = ({ isMobile }) => {
  const { i18n } = useTranslation();

  const handleChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  useEffect(() => {
    
    document.body.classList.remove("en", "gu", "hi");

    
    if (i18n.language === "en") {
      document.body.classList.add("en");
    } else if (i18n.language === "gu") {
      document.body.classList.add("gu");
    } else if (i18n.language === "hi") {
      document.body.classList.add("hi");
    }
  }, [i18n.language]); 

  return (
    <div
      style={{
        display: "inline-block",
        position: "relative",
        minWidth: isMobile ? "90%" : "100px", 
        zIndex: 1000,
        maxWidth: isMobile ? "100%" : "180px", 
        marginTop: isMobile ? "10px" : "0", 
      }}
    >
      <select
        value={i18n.language}
        onChange={handleChange}
        style={{
          width: "100%",
          height: isMobile ? "44px" : "34px", 
          borderRadius: "4px",
          border: "1px solid",
          borderColor: "black",
          backgroundColor: "white",
          color: "black",
          padding: isMobile ? "0 16px" : "0 10px", 
          fontSize: isMobile ? "16px" : "14px", 
          appearance: "none",
          cursor: "pointer", 
        }}
      >
        <option value="en">English</option>
        <option value="gu">ગુજરાતી</option>
        <option value="hi">हिन्दी</option>
      </select>

      {/* Custom arrow for dropdown */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: "10px",
          transform: "translateY(-50%)",
          pointerEvents: "none",
        }}
      >
        <i
          className="fas fa-chevron-down"
          style={{
            color: "black",
            fontSize: isMobile ? "20px" : "16px", 
          }}
        />
      </div>
    </div>
  );
};

export default LanguageSwitcher;
